// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"278":"fcb8d4e9","557":"fcb8d4e9","675":"fcb8d4e9"}[chunkId] + ".chunk.css";
};